import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from 'oidc-react';
import { PdsLoadingPage } from '@principal/design-system-react';
import { useGuestAuth } from './GuestAuthProvider';

interface GuestProtectedRouteProps {
    children: React.ReactNode;
    party: string;
}

const GuestProtectedRoute = ({ children, party }: GuestProtectedRouteProps) => {
    const oidcAuth = useAuth();
    const { isLoggedIn, isTokenValid, loading } = useGuestAuth();
    const location = useLocation();
    const params = useParams();
    const coverage = params?.coverage;
    const claimId = params?.claimId;
    const searchParams = new URLSearchParams(location.search);
    const formState = searchParams.get('formState');
    const code = searchParams.get('code');

    if (oidcAuth?.userData) {
        return <>{children}</>;
    }

    if (loading) {
        return <PdsLoadingPage />;
    }

    if (isLoggedIn && isTokenValid()) {
        return <>{children}</>;
    }

    if (coverage && formState && !code) {
        const recoverPath = claimId
            ? `/${coverage}/${claimId}/${party}/guest/recover?formState=${encodeURIComponent(formState)}`
            : `/${coverage}/${party}/guest/recover?formState=${encodeURIComponent(formState)}`;
        return <Navigate to={recoverPath} replace />;
    }

    if (coverage) {
        return <Navigate to={`/${coverage}/${party}/login`} state={{ from: location }} replace />;
    }

    return <Navigate to="/" replace />;
};

export default GuestProtectedRoute;
